import $ from 'cash-dom';

/**
 * This module looks for all elements with a "scrolly" class
 * and adds "scrolly-hidden" class on load.
 * When the element scrolls into view, the class is replaced with "scrolly-visible".
 * In css/scrolly.css those classes are used to fade elements in on scroll.
 */
export default class ScrollyModule {

    static name = 'scrolly';

    constructor(node) {

        this.elements = $('.scrolly');
        this.elements.each((i, el) => $(el).addClass('scrolly-hidden'));

        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    }

    handleScroll = (e) => {
        const y = window.pageYOffset;
        const windowHeight = window.innerHeight;

        let i=0;
        while(i<this.elements.length) {
            const $el = $(this.elements[i]);
            const offset = $el.offset().top;
            const scroll = y + windowHeight*0.75;
            const visible = scroll > offset;
            if(visible) {
                $el.removeClass('scrolly-hidden');
                $el.addClass('scrolly-visible');

                // remove from list
                this.elements.splice(i, 1);
            } else {
                i++;
            }
        }

        if(this.elements.length === 0) {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }
}